import {
  ColorProduct,
  Product,
  ProductSubDetailsData,
  fetchSingleProductColorPayload,
  InitialProductDetails,
} from "../product/ProductTypes";
import { Store } from "../store-list/StoreListTypes";

export const CATEGORY_CHANGE = "CATEGORY_CHANGE";
export const CANCEL_CATALOG_PAGE_LOADING = "CANCEL_CATALOG_PAGE_LOADING";
export const LOAD_PRODUCT_LIST = "LOAD_PRODUCT_LIST";
export const FETCH_PRODUCT_LIST = {
  START: "FETCH_PRODUCT_LIST_START",
  REQUEST: "FETCH_PRODUCT_LIST_REQUEST",
  SUCCESS: "FETCH_PRODUCT_LIST_SUCCESS",
  FAILURE: "FETCH_PRODUCT_LIST_FAILURE",
  STOP: "FETCH_PRODUCT_LIST_STOP",
};
export const FETCH_PRODUCTS_COLORS = {
  REQUEST: "FETCH_PRODUCTS_COLORS_REQUEST",
  SUCCESS: "FETCH_PRODUCTS_COLORS_SUCCESS",
  FAILURE: "FETCH_PRODUCTS_COLORS_FAILURE",
};
export const CHANGE_PRODUCT_LIST_SEQUENCE = "CHANGE_PRODUCT_LIST_SEQUENCE";
export const UPDATE_PRODUCT_LIST_SEQUENCE = {
  REQUEST: "UPDATE_PRODUCT_LIST_SEQUENCE_REQUEST",
  SUCCESS: "UPDATE_PRODUCT_LIST_SEQUENCE_SUCCESS",
  FAILURE: "UPDATE_PRODUCT_LIST_SEQUENCE_FAILURE",
};

export const LOAD_ASYNC_REQUEST_SERVICE_URL = "LOAD_ASYNC_REQUEST_SERVICE_URL";
export const UPDATE_PRODUCT_SEQUENCE_LIST_ASYNC = {
  REQUEST: "UPDATE_PRODUCT_SEQUENCE_LIST_ASYNC_REQUEST",
  SUCCESS: "UPDATE_PRODUCT_SEQUENCE_LIST_ASYNC_SUCCESS",
  FAILURE: "UPDATE_PRODUCT_SEQUENCE_LIST_ASYNC_FAILURE",
};
export const WEBSOCKET_CATEGORY_SAVE_STARTED =
  "WEBSOCKET_CATEGORY_SAVE_STARTED";
export const WEBSOCKET_CATEGORY_SAVE_COMPLETED =
  "WEBSOCKET_CATEGORY_SAVE_COMPLETED";
export const WEBSOCKET_CATEGORY_SAVE_FAILED = "WEBSOCKET_CATEGORY_SAVE_FAILED";

export const FETCH_IN_PROGRESS_REQUESTS_SNAPSHOT = {
  REQUEST: "FETCH_IN_PROGRESS_REQUESTS_SNAPSHOT_REQUEST",
  SUCCESS: "FETCH_IN_PROGRESS_REQUESTS_SNAPSHOT_SUCCESS",
  FAILURE: "FETCH_IN_PROGRESS_REQUESTS_SNAPSHOT_FAILURE",
};

export const CHECK_CATEGORY_SAVE = "CHECK_CATEGORY_SAVE";

export const UPDATE_PRODUCT_SEQUENCE_LIST_SYNC = {
  REQUEST: "UPDATE_PRODUCT_SEQUENCE_LIST_SYNC_REQUEST",
  SUCCESS: "UPDATE_PRODUCT_SEQUENCE_LIST_SYNC_SUCCESS",
  FAILURE: "UPDATE_PRODUCT_SEQUENCE_LIST_SYNC_FAILURE",
};
export const GET_PRODUCT_SEQUENCE_LIST = {
  REQUEST: "GET_PRODUCT_SEQUENCE_LIST_REQUEST",
  SUCCESS: "GET_PRODUCT_SEQUENCE_LIST_SUCCESS",
  DONE: "GET_PRODUCT_SEQUENCE_LIST_DONE",
  FAILURE: "GET_PRODUCT_SEQUENCE_LIST_FAILURE",
};
export const CHANGE_PINNED_PRODUCTS = "CHANGE_PINNED_PRODUCTS";
export const UPDATE_PINNED_PRODUCTS = {
  REQUEST: "UPDATE_PINNED_PRODUCTS_REQUEST",
  SUCCESS: "UPDATE_PINNED_PRODUCTS_SUCCESS",
  FAILURE: "UPDATE_PINNED_PRODUCTS_FAILURE",
};
export const UPDATE_PRODUCT_LIST_IN_STATE = "UPDATE_PRODUCT_LIST_IN_STATE";
export const UPDATE_PRODUCT_LIST_SEQUENCE_MODE =
  "UPDATE_PRODUCT_LIST_SEQUENCE_MODE";
// export const RESET_PRODUCT_SEQUENCE_STATE = "RESET_PRODUCT_SEQUENCE_STATE";
export const RESET_PRODUCT_SEQUENCE = "RESET_PRODUCT_SEQUENCE";
export const RESET_PRODUCT_LIST = "RESET_PRODUCT_LIST";
export const UPDATE_NUMBER_OF_PINNED_PRODUCTS =
  "UPDATE_NUMBER_OF_PINNED_PRODUCTS";
export const SET_PINNED_PRODUCTS_MODE = "SET_PINNED_PRODUCTS_MODE";
export const FETCH_SORTING_LIST = {
  REQUEST: "FETCH_SORTING_LIST_REQUEST",
  SUCCESS: "FETCH_SORTING_LIST_SUCCESS",
  FAILURE: "FETCH_SORTING_LIST_FAILURE",
};
export const LOAD_SORTING_LIST = "LOAD_SORTING_LIST";
export const SET_SORTING_RULE = "SET_SORTING_RULE";
export const LOAD_SORTED_PRODUCTS = "LOAD_SORTED_PRODUCTS";

export const FETCH_SORTED_PRODUCTS = {
  REQUEST: "FETCH_SORTED_PRODUCTS_REQUEST",
  SUCCESS: "FETCH_SORTED_PRODUCTS_SUCCESS",
  FAILURE: "FETCH_SORTED_PRODUCTS_FAILURE",
};

export const ASYNC_SORT_PROGRESS = {
  START: "ASYNC_SORT_PROGRESS_START",
  STOP: "ASYNC_SORT_PROGRESS_STOP",
};

export const SET_ACTIVE_SORTING_RULE = "SET_ACTIVE_SORTING_RULE";
export const UPDATE_PRODUCT_SEQUENCE = "UPDATE_PRODUCT_SEQUENCE";

export const GET_PRODUCT_SEQUENCE = "GET_PRODUCT_SEQUENCE";
export const RESET_SEQUENCE_REQUESTED_BY_BOOST_BURY =
  "RESET_SEQUENCE_REQUEST_BY_BOOST_BURY";

export const REFRESH_PRODUCT = {
  REQUEST: "REFRESH_PRODUCT_REQUEST",
  SUCCESS: "REFRESH_PRODUCT_SUCCESS",
  FAILURE: "REFRESH_PRODUCT_FAILURE",
};

export const FETCH_PRODUCT = {
  REQUEST: "FETCH_PRODUCT_REQUEST",
  SUCCESS: "FETCH_PRODUCT_SUCCESS",
  FAILURE: "FETCH_PRODUCT_FAILURE",
};

export const FETCH_PRODUCT_IDS = {
  REQUEST: "FETCH_PRODUCT_IDS_REQUEST",
  SUCCESS: "FETCH_PRODUCT_IDS_SUCCESS",
  FAILURE: "FETCH_PRODUCT_IDS_FAILURE",
};

export const FETCH_PREV_PRODUCT_IDS = {
  REQUEST: "FETCH_PREV_PRODUCT_IDS_REQUEST",
  SUCCESS: "FETCH_PREV_PRODUCT_IDS_SUCCESS",
  FAILURE: "FETCH_PREV_PRODUCT_IDS_FAILURE",
};

export const FETCH_NEXT_PRODUCT_IDS = {
  REQUEST: "FETCH_NEXT_PRODUCT_IDS_REQUEST",
  SUCCESS: "FETCH_NEXT_PRODUCT_IDS_SUCCESS",
  FAILURE: "FETCH_NEXT_PRODUCT_IDS_FAILURE",
};

export const REFRESH_PRODUCT_COLOR = {
  REQUEST: "REFRESH_PRODUCT_COLOR_REQUEST",
  SUCCESS: "REFRESH_PRODUCT_COLOR_SUCCESS",
  FAILURE: "REFRESH_PRODUCT_COLOR_FAILURE",
};

export const FETCH_WATCHED_PRODUCT_LIST = {
  REQUEST: "FETCH_WATCHED_PRODUCT_LIST_REQUEST",
  SUCCESS: "FETCH_WATCHED_PRODUCT_LIST_SUCCESS",
  FAILURE: "FETCH_WATCHED_PRODUCT_LIST_FAILURE",
};

export const ADD_PRODUCT_TO_WATCH_LIST = {
  REQUEST: "ADD_PRODUCT_TO_WATCH_LIST_REQUEST",
  SUCCESS: "ADD_PRODUCT_TO_WATCH_LIST_SUCCESS",
  FAILURE: "ADD_PRODUCT_TO_WATCH_LIST_FAILURE",
};

export const REMOVE_PRODUCT_FROM_WATCH_LIST = {
  REQUEST: "REMOVE_PRODUCT_FROM_WATCH_LIST_REQUEST",
  SUCCESS: "REMOVE_PRODUCT_FROM_WATCH_LIST_SUCCESS",
  FAILURE: "REMOVE_PRODUCT_FROM_WATCH_LIST_FAILURE",
};

export const LOCK_PRODUCT = {
  REQUEST: "LOCK_PRODUCT_REQUEST",
  SUCCESS: "LOCK_PRODUCT_SUCCESS",
  FAILURE: "LOCK_PRODUCT_FAILURE",
};

export const UNLOCK_PRODUCT = {
  REQUEST: "UNLOCK_PRODUCT_REQUEST",
  SUCCESS: "UNLOCK_PRODUCT_SUCCESS",
  FAILURE: "UNLOCK_PRODUCT_FAILURE",
};

export const FETCH_LOCKS_FOR_CATEGORY = {
  REQUEST: "FETCH_LOCKS_FOR_CATEGORY_REQUEST",
  SUCCESS: "FETCH_LOCKS_FOR_CATEGORY_SUCCESS",
  FAILURE: "FETCH_LOCKS_FOR_CATEGORY_FAILURE",
};
export const LOAD_PRODUCT_POSITION_SERVICE_URL =
  "LOAD_PRODUCT_POSITION_SERVICE_URL";

export const LOCK_PRODUCT_COMPLETED = "LOCK_PRODUCT_COMPLETED";

export const UNLOCK_PRODUCT_COMPLETED = "UNLOCK_PRODUCT_COMPLETED";

export const BUSINESS_RULES_SERVICE_URL = "BUSINESS_RULES_SERVICE_URL";

export const RESET_LOCKS_IN_CATEGORY = "RESET_LOCKS_IN_CATEGORY";

export const SET_LOCKED_UNLOCKED_PRODUCTS = "SET_LOCKED_UNLOCKED_PRODUCTS";

export const RESET_SAVED_LOCKED_UNLOCKED_PRODUCTS =
  "RESET_SAVED_LOCKED_UNLOCKED_PRODUCTS";

export const GET_CONTENT_SLOTS = {
  REQUEST: "GET_CONTENT_SLOTS_REQUEST",
  SUCCESS: "GET_CONTENT_SLOTS_SUCCESS",
  FAILURE: "GET_CONTENT_SLOTS_FAILURE",
};

export const LOAD_CONTENT_SLOTS_SERVICE_URL = "LOAD_CONTENT_SLOTS_SERVICE_URL";

export const REVERT_PRODUCT_SEQUENCE = "REVERT_PRODUCT_SEQUENCE";

export const RESET_CONTENT_SLOTS = "RESET_CONTENT_SLOTS";

export const ADD_CONTENT_SLOT = {
  REQUEST: "ADD_CONTENT_SLOT_REQUEST",
  SUCCESS: "ADD_CONTENT_SLOT_SUCCESS",
  FAILURE: "ADD_CONTENT_SLOT_FAILURE",
};

export const UPDATE_CONTENT_SLOT_STATE = "UPDATE_CONTENT_SLOT_STATE";

export const UPDATE_CONTENT_SLOT = {
  REQUEST: "UPDATE_CONTENT_SLOT_REQUEST",
  SUCCESS: "UPDATE_CONTENT_SLOT_SUCCESS",
  FAILURE: "UPDATE_CONTENT_SLOT_FAILURE",
};

export const ADD_UPDATE_CONTENT_SLOT = "ADD_UPDATE_CONTENT_SLOT";

export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";

export const UPDATE_PROGRESS_CACHE = "UPDATE_PROGRESS_CACHE";

export const DELETE_UPDATE_CONTENT_SLOT = "DELETE_UPDATE_CONTENT_SLOT";

export const DELETE_CONTENT_SLOT = {
  REQUEST: "DELETE_CONTENT_SLOT_REQUEST",
  SUCCESS: "DELETE_CONTENT_SLOT_SUCCESS",
  FAILURE: "DELETE_CONTENT_SLOT_FAILURE",
};

export const DELETE_CONTENT_SLOT_COMPLETED = "DELETE_CONTENT_SLOT_COMPLETED";

export const SET_PINNED_PRODUCTS = {
  REQUEST: "SET_PINNED_PRODUCTS_REQUEST",
  SUCCESS: "SET_PINNED_PRODUCTS_SUCCESS",
  FAILURE: "SET_PINNED_PRODUCTS_FAILURE",
};

export const SET_PINNED_UNPINNED_PRODUCTS = "SET_PINNED_UNPINNED_PRODUCTS";

export const BULK_SET_PINNED_UNPINNED_PRODUCTS =
  "BULK_SET_PINNED_UNPINNED_PRODUCTS";

export const RESET_STORED_PINNED_UNPINNED_PRODUCT_IDS =
  "RESET_STORED_PINNED_UNPINNED_PRODUCT_IDS";

export const RESET_PINNED_UNPINNED_PRODUCTS = "RESET_PINNED_UNPINNED_PRODUCTS";

export const GET_PINNED_PRODUCTS = {
  REQUEST: "GET_PINNED_PRODUCTS_REQUEST",
  SUCCESS: "GET_PINNED_PRODUCTS_SUCCESS",
  FAILURE: "GET_PINNED_PRODUCTS_FAILURE",
};

export const SET_CONTENT_SLOT_LOADING = "SET_CONTENT_SLOT_LOADING";
export const RESET_CONTENT_SLOT_LOADING = "RESET_CONTENT_SLOT_LOADING";

export const DISCARD_OUT_OF_POSITION_PRODUCTS =
  "DISCARD_OUT_OF_POSITION_PRODUCTS";

export const FETCH_PAGE_COLOR_BADGE_DATA = {
  REQUEST: "FETCH_PAGE_COLOR_BADGE_DATA_REQUEST",
  SUCCESS: "FETCH_PAGE_COLOR_BADGE_DATA_SUCCESS",
  FAILURE: "FETCH_PAGE_COLOR_BADGE_DATA_FAILURE",
};

export const FETCH_PRODUCT_DETAILS_PER_PAGE = {
  REQUEST: "FETCH_PRODUCT_DETAILS_PER_PAGE_REQUEST",
  SUCCESS: "FETCH_PRODUCT_DETAILS_PER_PAGE_SUCCESS",
  FAILURE: "FETCH_PRODUCT_DETAILS_PER_PAGE_FAILURE",
};

export const SET_SELECTED_ITEMS = "SET_SELECTED_ITEMS";

export const LOAD_INITIAL_PRODUCTS_DETAILS = {
  REQUEST: "LOAD_INITIAL_PRODUCTS_DETAILS_REQUEST",
  SUCCESS: "LOAD_INITIAL_PRODUCTS_DETAILS_SUCCESS",
  FAILURE: "LOAD_INITIAL_PRODUCTS_DETAILS_FAILURE",
};

export const RESET_PROGRESS_CACHE = "RESET_PROGRESS_CACHE";

export const ASSIGN_PRODUCT_POSITION = "ASSIGN_PRODUCT_POSITION";

export const RESET_POSITIONED_PRODUCT_IDS = "RESET_POSITIONED_PRODUCT_IDS";

export const UPDATE_PRODUCT_POSITION = "UPDATE_PRODUCT_POSITION";

export const REMOVE_PRODUCT_POSITION = "REMOVE_PRODUCT_POSITION";

export const UPDATE_SORTED_PRODUCTS_POSITIONS =
  "UPDATE_SORTED_PRODUCTS_POSITIONS";

export const SET_PREVIEW_OPTIONS = "SET_PREVIEW_OPTIONS";

export const SET_PREVIEW_MODE = "SET_PREVIEW_MODE";

export const RESET_PREVIEW = "RESET_PREVIEW";

export const LOAD_REMAINING_PRODUCTS = {
  REQUEST: "LOAD_REMAINING_PRODUCTS_REQUEST",
  SUCCESS: "LOAD_REMAINING_PRODUCTS_SUCCESS",
  FAILURE: "LOAD_REMAINING_PRODUCTS_FAILURE",
  CANCEL: "LOAD_REMAINING_PRODUCTS_CANCEL",
};

export const SET_REMAINING_PRODUCTS_MODAL = "SET_REMAINING_PRODUCTS_MODAL";

export const SET_IS_NEW_CATEGORY = "SET_IS_NEW_CATEGORY";

export const CLEAR_PENDING_SAVE_REQUEST_ID = "CLEAR_PENDING_SAVE_REQUEST_ID";

export const FETCH_SORTED_PRODUCTS_ASYNC = {
  REQUEST: "FETCH_SORTED_PRODUCTS_ASYNC_REQUEST",
  SUCCESS: "FETCH_SORTED_PRODUCTS_ASYNC_SUCCESS",
  FAILURE: "FETCH_SORTED_PRODUCTS_ASYNC_FAILURE",
};

export type AsyncSortProgressAction =
  | { type: typeof ASYNC_SORT_PROGRESS.START }
  | { type: typeof ASYNC_SORT_PROGRESS.STOP };

export type ProductListActionTypes =
  | SetPreviewOptionsAction
  | SetPreviewModeAction
  | ResetPreviewAction
  | LoadProductsFromCategoryResponseAction
  | UpdateProductSequencesResponseAction
  | updateProductListInStateAction
  | updateProductListSequenceModeAction
  | ResetProductList
  | UpdateNumberOfPinnedProductsAction
  | SetPinnedProductsModeAction
  | SetSortingRuleAction
  | UpdateProductListSequenceAction
  | LoadSortingRulesListResponseAction
  | GetSortedProductsListAction
  | LoadSortedProductsListFromSortAction
  | AsyncSortProgressAction;

export interface ChangeCategoryAction {
  type: typeof CATEGORY_CHANGE;
}

/**
 * Load category to product types
 */
export interface LoadProductsFromCategoryAction {
  payload: GetProductListPayload;
  type: typeof LOAD_PRODUCT_LIST;
}

export interface LoadProductsFromCategoryResponseAction {
  payload: GetProductsFromCategoryResponsePayload;
  type: typeof FETCH_PRODUCT_LIST.SUCCESS;
}

export interface GetProductsFromCategoryResponsePayload {
  // count: number;
  results: CategoryToProductData[];
  categoryId?: string;
  // total: number;
  // storeId: string;
  storeListIds: Store[];
}

export interface GetProductListPayload {
  catalogId: string;
  categoryId: string;
  localeCode: string | null;
  storeId: string;
  productIds?: string[];
  next?: string;
  count?: number;
  total?: number;
  totalPagesFetched?: Number;
  storeListIds: Store[]; // TODO Remove this...  store specific values should be derived at the selector level.
  isRefreshingAllProducts?: boolean; // ideally, refreshing all should be a separate action rather than a flag
  pageProductIds?: string[];
  products?: Product[];
  isRefreshingFromProductGroupMgmt?: boolean;
  isCategoryProductsV2Available?: boolean;
  page?: number;
  isLastPage?: boolean;
  isCatalogIdRequired?: boolean;
}

export interface GetSortedListPayload {
  catalogId: string;
  categoryId: string;
  localeId: string;
  storeId: string;
  currencyCode: string;
}
export interface CategoryToProductData {
  // descriptions?: PublishedObj[];
  // isPublished?: boolean;
  // overrides?: Overrides[];
  // id: string;
  // code: string;
  // name: string;
  // thumbnail: string;
  // position: number;
  // isPublished: boolean;
  // typeCode: string;
  // updatedAt: string;
  // translations: {
  //   localeCode: string;
  //   name: string;
  // };
  // sequence: number;
  productId: string;
  cachedProduct: ProductSubDetailsData;
  // product: {
  //   productId?: string;
  //   code: string;
  //   typeCode: string;
  //   name: string;
  //   thumbnail: string;
  //   isPublished: true;
  //   translations: [
  //     {
  //       localeCode: string;
  //       name: string;
  //       thumbnail: string;
  //       isPublished: true;
  //       url: string;
  //     }
  //   ];
  //   url: string;
  //   stock: number;
  //   stockValue: number;
  //   listPrice: number;
  // colors: [
  //   {
  //     sequence: 0;
  //     name: string;
  //     swatchImage: string;
  //     thumbnail: string;
  //     code: string;
  //     colorId: string;
  //     translations: [
  //       {
  //         localeCode: string;
  //         name: string;
  //         swatchImage: string;
  //         thumbnail: string;
  //       }
  //     ];
  //   }
  // ];
}

export interface WatchedProductListData {
  productId: string;
  storeId: string;
  watchers: string[];
}

export interface WatchedProductListResponse {
  results: WatchedProductListData[];
}

/**
 * Update product list sequence types
 */
export interface UpdateProductListSequenceAction {
  payload: UpdateSequencePayload;
  type: typeof CHANGE_PRODUCT_LIST_SEQUENCE;
}
export interface UpdateProductSequenceAction {
  payload: UpdateProductSequencePayload;
  type: typeof UPDATE_PRODUCT_SEQUENCE;
}

export interface GetProductSequenceAction {
  payload: GetProductSequencePayload;
  type: typeof GET_PRODUCT_SEQUENCE;
}

export interface GetProductSequencePayload {
  requestId: string;
  isUpdateFunctionInvoked?: boolean;
  isFromProductDeleteOperation?: boolean;
  categoryId?: string;
}

export interface UpdateProductSequences {
  payload: UpdateSequencePayload;
  type: typeof UPDATE_PRODUCT_LIST_SEQUENCE;
}

export interface UpdateProductSequencesResponseAction {
  products: ProductSequenceData[];
  type: typeof UPDATE_PRODUCT_LIST_SEQUENCE.SUCCESS;
}

export interface UpdateSequencePayload {
  catalogId: string;
  categoryId: string;
  productSequences: ProductSequenceParams[];
}
export interface UpdateProductSequencePayload {
  categoryId: string;
  productIds: string[];
  isFromProductDeleteOperation?: boolean;
  unmanagedProductIds?: string[];
}

export interface ProductSequenceParams {
  productId: string;
  sequence?: number;
}

export interface UpdateProductSequenceResponse {
  type: string;
  payload: UpdateProductSequenceResponsePayload;
  error: string;
}

export interface UpdateProductSequenceResponsePayload {
  data: UpdateCategoryToProduct;
  variables: UpdateProductSequenceVariables;
}

export interface UpdateProductSequenceVariables {
  catalogId: string;
  categoryId: string;
  productId: string;
}

export interface UpdateCategoryToProduct {
  [name: string]: AffectedRows;
  insert_SyncLog: AffectedRows;
}

export interface AffectedRows {
  affected_rows: number;
}

/**
 * Update product list in state types
 */
export interface updateProductListInStateAction {
  payload: UpdateProductInStatePayload;
  type: typeof UPDATE_PRODUCT_LIST_IN_STATE;
}

export interface UpdateProductInStatePayload {
  products: ProductSequenceData[];
  isSaveAction: boolean;
}

/**
 * Update sequence mode in state types
 */
export interface updateProductListSequenceModeAction {
  sequenceMode: number;
  type: typeof UPDATE_PRODUCT_LIST_SEQUENCE_MODE;
}

/**
 * Reset product list state types
 */
export interface ResetProductList {
  type: typeof RESET_PRODUCT_LIST;
}

export interface ResetProductSequence {
  type: typeof RESET_PRODUCT_SEQUENCE;
}

export interface RevertProductSequence {
  type: typeof REVERT_PRODUCT_SEQUENCE;
}

export interface ProductSequenceData {
  productId: string;
  sequence?: number;
  isInitialPositionAvailable?: boolean;
  isRecentlyAdded?: boolean;
  isLocked?: boolean;
  type?: string;
  slotId?: string;
  position?: number;
}

export interface ProductIdsData {
  productIds: string[];
  categoryId: string;
  count: number;
  total: number;
  next?: string;
}

export interface ProductListSequenceResponse {
  accountId: string;
  requestId: string;
  response: Response;
}

interface Response {
  statusCode: number;
  body: string;
}

export interface ProductPublishedData {
  descriptions?: PublishedObj[];
  isPublished: boolean;
  overrides?: Overrides[];
  storeSpecific?: Object;
  imageGroups?: {
    images: {
      imageId: string;
      thumbnail: string;
    }[];
    variationAttributes: {
      attributeId: string;
      values: {
        value: string;
      }[];
    }[];
  }[];
  categorySpecific?: {
    categoryId: string;
    leadingColorId?: string;
    leadingImageId?: string;
  }[];
  isUpdatingPublishFlag?: boolean;
  code?: string;
  variationBaseId?: string;
  thumbnail?: string;
  name?: string;
}

export interface PublishedObj {
  isPublished: boolean;
}
export interface Overrides {
  isPublished: boolean | null;
  storeId: string;
}

export interface UpdateNumberOfPinnedProductsAction {
  payload: {
    numberOfPinnedProducts: number;
  };
  type: typeof UPDATE_NUMBER_OF_PINNED_PRODUCTS;
}

export interface UpdatePinnedProductsAction {
  payload: UpdatePinnedProductsPayload;
  type: typeof CHANGE_PINNED_PRODUCTS;
}

export interface UpdatePinnedProductsPayload {
  storeId: string;
  catalogId: string;
  categoryId: string;
  pinnedProducts: string[];
}

export interface UpdatePinnedProductsResponse {
  type: string;
  payload: UpdatePinnedProductResponsePayload;
  error: string;
}

export interface UpdatePinnedProductResponsePayload {
  data: UpdatePinnedProducts;
  variables: UpdatePinnedProductVariables;
}

export interface UpdatePinnedProducts {
  [name: string]: AffectedRows;
  insert_SyncLog: AffectedRows;
}

export interface UpdatePinnedProductVariables {
  storeId: string;
  catalogId: string;
  categoryId: string;
  productId: string;
}

export interface PinnedProductsData {
  PinnedProduct: PinnedProductData[];
}

export interface PinnedProductData {
  productId: string;
}

export type ProductId = string;

export interface SetPinnedProductsModeAction {
  isPinnedProductsMode: boolean;
  type: typeof SET_PINNED_PRODUCTS_MODE;
}

/**
 * Set sorting rule types
 */

export interface SetSortingRuleAction {
  rule: string;
  type: typeof SET_SORTING_RULE;
}

export interface LoadSortingRulesListFromSortAction {
  type: typeof LOAD_SORTING_LIST;
}

export interface LoadSortedProductsListFromSortAction {
  payload: LoadSortedProductsListFromSortPayload;
  type: typeof LOAD_SORTED_PRODUCTS;
}

export interface LoadSortedProductsListFromSortPayload {
  rule: string;
  selectedSortPeriod?: string;
  timeZone?: string;
  isUnmanagedProductsSupported?: boolean;
}
export interface Attributes {
  attr: string;
  value: string;
  points: number;
}
export interface FormulaNode {
  metric: string;
  order: string;
  weight: number;
}

export interface SortingPointsLUTNode {
  attr: string;
  value: string;
  points: number;
}
export interface MultiCriteriaNode {
  ruleType: string;
  strategy?: string;
  sortingPointsLUT: SortingPointsLUTNode[];
  dateRange?: string;
  timezone?: string;
  formula: FormulaNode[];
}

export interface BusinessRulesListDetails {
  ruleType: string;
  name: string;
  description: string;
  createdAt: string;
  updatedAt: string;
  ruleId: string;

  // only applicable if ruleType == "WS": {
  dateRange?: string;
  timezone?: string;
  formula: FormulaNode[];
  // }

  // only applicable if ruleType == "AS": {
  strategy?: string;
  sortingPointsLUT: SortingPointsLUTNode[];
  // }

  // only applicable if ruleType == "MCS": {
  criteria: MultiCriteriaNode[];
}

export interface SortingRulesListPayload {
  results: BusinessRulesListDetails[];
}
export interface LoadSortingRulesListResponseAction {
  type: typeof FETCH_SORTING_LIST;
  total: number;
  payload: SortingRulesListPayload;
}

export interface productColorsDataPayload {
  results: productColorsData[];
}

export interface productColorsData {
  productId: string;
  cachedProduct: cachedColorProduct;
}

export interface cachedColorProduct {
  cachedAt: string;
  product: ColorProduct;
}

export interface LoadProductColorsAction {
  type: typeof REFRESH_PRODUCT_COLOR.REQUEST;
  payload: fetchSingleProductColorPayload;
}

export interface addRemoveProductInWatchListPayload {
  productId: string;
  storeId: string;
  watcher: string;
}

export interface watchProductAction {
  type: typeof ADD_PRODUCT_TO_WATCH_LIST.REQUEST;
  payload: addRemoveProductInWatchListPayload;
}

export interface unWatchProductAction {
  type: typeof REMOVE_PRODUCT_FROM_WATCH_LIST.REQUEST;
  payload: addRemoveProductInWatchListPayload;
}

export interface LockProductAction {
  type: typeof LOCK_PRODUCT.REQUEST;
  payload: lockedProductsPayload;
}

export interface UnLockProductAction {
  type: typeof UNLOCK_PRODUCT.REQUEST;
  payload: unlockedProductsPayload;
}

export interface GetLocksInCategoryAction {
  type: typeof FETCH_LOCKS_FOR_CATEGORY.REQUEST;
  payload: getLocksInCategoryPayload;
}

export interface lockUnLockProductPayload {
  productId: string;
  catalogId: string;
  categoryId: string;
  position: number;
  isLocked?: boolean;
}

export interface getLocksInCategoryPayload {
  catalogId: string;
  categoryId: string;
}

export interface LocksInCategory {
  catalogId: string;
  categoryId: string;
  position: number;
  productId: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface LocksInCategoryResponse {
  results: LocksInCategory[];
}

export interface LockProductCompletedAction {
  type: typeof LOCK_PRODUCT_COMPLETED;
  payload: LocksInCategory;
}

export interface UnLockProductCompletedAction {
  type: typeof UNLOCK_PRODUCT_COMPLETED;
  payload: UnLockProductResponsePayload;
}

export interface UnLockProductResponsePayload {
  catalogId: string;
  categoryId: string;
  position: number;
  productId: string;
}

export interface lockedProductsPayload {
  lockedProducts: lockUnLockProductPayload[];
}

export interface unlockedProductsPayload {
  unlockedProducts: lockUnLockProductPayload[];
}

export interface getContentSlotsPayload {
  storeId: string;
  catalogId: string;
  categoryId: string;
}

export interface getContentSlotsAction {
  type: typeof GET_CONTENT_SLOTS.REQUEST;
  payload: getContentSlotsPayload;
}

export interface ContentSlot {
  slotId: string;
  position: number;
  type: string;
}

export interface ContentSlotsResponse {
  slots: ContentSlot[];
}

export interface addContentSlotPayload {
  storeId: string;
  catalogId: string;
  categoryId: string;
  position: number;
}
export interface ProductsData {
  count: number;
  total: number;
  next?: string;
  results: InitialProductDetails[];
}

export interface addContentSlotAction {
  type: typeof ADD_CONTENT_SLOT.REQUEST;
  payload: addContentSlotPayload;
}

export interface updateContentSlotStateResponse {
  slotId: string;
  position: number;
}

export interface updateContentSlotStateAction {
  type: typeof UPDATE_CONTENT_SLOT_STATE;
  payload: updateContentSlotStateResponse;
}

export interface updateContentSlotPayload {
  slotId: string;
  position: number;
}

export interface updateContentSlotAction {
  type: typeof UPDATE_CONTENT_SLOT.REQUEST;
  payload: updateContentSlotPayload;
}

export interface deleteContentSlotPayload {
  slotId: string;
}

export interface deleteContentSlotAction {
  type: typeof DELETE_CONTENT_SLOT.REQUEST;
  payload: deleteContentSlotPayload;
}

export interface pinnedProductsPayload {
  pinnedProductIds: string[];
  sortOption: string;
  catalogId: string;
  categoryId: string;
}

export interface pinnedProductsAction {
  type: typeof SET_PINNED_PRODUCTS.REQUEST;
  payload: pinnedProductsPayload;
}

export interface pinnedUnPinnedProductsPayload {
  productId: string;
  isPinned: boolean;
  catalogId: string;
  categoryId: string;
}

export interface pinnedUnPinnedProductsAction {
  type: typeof SET_PINNED_UNPINNED_PRODUCTS;
  payload: pinnedUnPinnedProductsPayload;
}

export interface bulkPinnedUnPinnedProductsPayload {
  toUnpin: string[];
  toPin: string[];
  catalogId: string;
  categoryId: string;
}

export interface bulkPinnedUnPinnedProductsAction {
  type: typeof BULK_SET_PINNED_UNPINNED_PRODUCTS;
  payload: bulkPinnedUnPinnedProductsPayload;
}

export interface getPinnedProductsAction {
  type: typeof GET_PINNED_PRODUCTS.REQUEST;
  payload: getPinnedProductsPayload;
}

export interface getPinnedProductsResponse {
  results: {
    catalogId: string;
    categoryId: string;
    pinnedProductIds: string[];
    sortOption: string;
    createdAt: string;
    updatedAt: string;
  }[];
}

export interface getPinnedProductsPayload {
  catalogId: string;
  categoryId: string;
}

export interface discardOutOfPositionProductsPayload {
  catalogId: string;
  categoryId: string;
  pinnedProductIds: string[];
  sortOption: string;
  unlockedProducts: LocksInCategory[];
  isPinnedProductsOutOfPosition: boolean;
  isProductsOutsidePinnedArea: boolean;
}

export interface DiscardOutOfPositionProductsAction {
  type: typeof DISCARD_OUT_OF_POSITION_PRODUCTS;
  payload: discardOutOfPositionProductsPayload;
}

export interface addUpdateContentSlotAction {
  type: typeof ADD_UPDATE_CONTENT_SLOT;
  payload: addContentSlotPayload;
}

export interface deleteUpdateContentSlotAction {
  type: typeof DELETE_UPDATE_CONTENT_SLOT;
  payload: deleteContentSlotPayload;
}

export interface SetContentSlotLoadingAction {
  type: typeof SET_CONTENT_SLOT_LOADING;
}

export interface ResetContentSlotLoadingAction {
  type: typeof RESET_CONTENT_SLOT_LOADING;
}

export interface FetchPageColorBadgeDataAction {
  type: typeof FETCH_PAGE_COLOR_BADGE_DATA.REQUEST;
  payload: GetProductListPayload;
}

export interface SetSelectedItemsAction {
  type: typeof SET_SELECTED_ITEMS;
  payload: { items: ProductSequenceData[]; isDraggedItems?: boolean };
}

export interface FetchProductDetailsPerPageAction {
  type: typeof FETCH_PRODUCT_DETAILS_PER_PAGE.REQUEST;
  payload: {
    categoryId: string;
    catalogId: string;
    storeId: string | null;
    localeCode: string | null;
    productIds: string[];
    page: number;
    pageSize: number;
  };
}

export interface SetCurrentPageAction {
  type: typeof SET_CURRENT_PAGE;
  payload: number;
}

export interface UpdateProgressCacheAction {
  type: typeof UPDATE_PROGRESS_CACHE;
  payload: {
    categoryId: string;
    page: number;
    progress: number;
  };
}

export interface LoadProductsPerPagePayload {
  categoryId: string;
  catalogId: string;
  storeId: string | null;
  localeCode: string | null;
  productIds?: string[];
  page: number;
  pageSize: number;
}

export interface assignProductPositionPayload {
  productId: string;
}

export interface AssignProductPositionAction {
  type: typeof ASSIGN_PRODUCT_POSITION;
  payload: assignProductPositionPayload;
}

export interface removeProductPositionPayload {
  productId: string;
}

export interface RemoveProductPositionAction {
  type: typeof REMOVE_PRODUCT_POSITION;
  payload: removeProductPositionPayload;
}

export interface updateSortedProductsPositionsPayload {
  promotedProducts: string[];
  demotedProducts: string[];
  categoryId: string;
  catalogId: string;
}

export interface UpdateSortedProductsPositionsAction {
  type: typeof UPDATE_SORTED_PRODUCTS_POSITIONS;
  payload: updateSortedProductsPositionsPayload;
}

export interface setPreviewOptionsPayload {
  date: string | null;
  stock: boolean;
  published: boolean;
  products?: Record<string, any>;
}

export interface SetPreviewOptionsAction {
  type: typeof SET_PREVIEW_OPTIONS;
  payload: setPreviewOptionsPayload;
}

export interface setPreviewModePayload {
  isPreviewMode: boolean;
}
export interface SetPreviewModeAction {
  type: typeof SET_PREVIEW_MODE;
  payload: setPreviewModePayload;
}

export interface ResetPreviewAction {
  type: typeof RESET_PREVIEW;
}

export interface LoadRemainingProductsAction {
  type: typeof LOAD_REMAINING_PRODUCTS.REQUEST;
  payload: LoadRemainingProductsPayload;
}

export interface LoadRemainingProductsPayload {
  categoryId: string;
  catalogId: string;
  storeId: string | null;
  localeCode: string | null;
  allProductIds: string[];
  pageProductIds: string[];
}

export interface SetRemainingProductsModalAction {
  type: typeof SET_REMAINING_PRODUCTS_MODAL;
  payload: SetRemainingProductsModalPayload;
}

export interface SetRemainingProductsModalPayload {
  isOpen: boolean;
  progress?: number;
  total?: number;
  loaded?: number;
}

export interface WebSocketCategorySaveStartedAction {
  type: typeof WEBSOCKET_CATEGORY_SAVE_STARTED;
  payload: { categoryId: string };
}

export interface WebSocketCategorySaveCompletedAction {
  type: typeof WEBSOCKET_CATEGORY_SAVE_COMPLETED;
  payload: { categoryId: string; requestId: string };
}

export interface WebSocketCategorySaveFailedAction {
  type: typeof WEBSOCKET_CATEGORY_SAVE_FAILED;
  payload: { categoryId: string; requestId: string; errorMessage?: string };
}

export interface FetchInProgressRequestsSnapshotAction {
  type: typeof FETCH_IN_PROGRESS_REQUESTS_SNAPSHOT.REQUEST;
  payload: { accountId: string };
}

export interface InProgressResponsePayload {
  requests: InProgressRequest[];
}

export interface InProgressRequest {
  status: string;
  type: string;
  accountId: string;
  requestId: string;
  request: {
    routeUrl: string;
    params: {
      accountId: string;
      categoryId: string;
    };
    headers: {
      "x-catalog-id": string;
      "x-store-id": string;
      "x-locale-code": string;
    };
  };
  createdAt: string;
  updatedAt: string;
  userId: string;
  userName: string;
}

export interface FetchInProgressRequestsSnapshotSuccessAction {
  type: typeof FETCH_IN_PROGRESS_REQUESTS_SNAPSHOT.SUCCESS;
  payload: InProgressResponsePayload;
}

export interface FetchInProgressRequestsSnapshotFailureAction {
  type: typeof FETCH_IN_PROGRESS_REQUESTS_SNAPSHOT.FAILURE;
}

export interface CheckCategorySaveAction {
  type: typeof CHECK_CATEGORY_SAVE;
  payload: { categoryId: string };
}
export interface ClearPendingSaveRequestIdAction {
  type: typeof CLEAR_PENDING_SAVE_REQUEST_ID;
  payload: { requestId: string };
}

export interface GetSortedProductsListPayload {
  requestId: string;
  categoryId: string;
  catalogId: string;
  ruleId: string;
  isUnmanagedProductsSupported: boolean;
}

export interface GetSortedProductsListAction {
  type: typeof FETCH_SORTED_PRODUCTS;
  payload: GetSortedProductsListPayload;
}
